import { Component, OnInit, ElementRef, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataTablesResponse } from '../../shared/models/datatables-response';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../../environments/environment'
import { ValidationService } from '../../shared/providers/validation.service';

@Component({
  selector: 'app-my1031-inquiry-list',
  templateUrl: './my1031-inquiry-list.component.html',
  styleUrls: ['./my1031-inquiry-list.component.css']
})
export class My1031InquiryListComponent implements OnInit {
  protected readonly BASE_URL: string = environment.base_url;
  dtOptions = {};
  table: DataTableDirective;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;
  constructor(private router: Router, public valdateService: ValidationService, private http: HttpClient, private authService: AuthenticationService) { }
  inquiryList = [];
  IsLoading = false;
  ngOnInit() {
    const that = this;
    this.dtOptions = {
      pagingType: 'full_numbers',
      serverSide: true,
      processing: true,
      info: false,
      language: {
        zeroRecords: null,
        processing: `<div class="custom-dt-loader">
        <div class="circle-loader-wrapper">
          <div class="circle-loader-ring"></div>
          <img src="assets/img/logos/logo.png" class="loader-icon" />
        </div>
      </div>
     `,
      },
      "pageLength": 50,
      "order": [[0, "desc"]],
      bLengthChange: false,
      initComplete: () => $('.dataTables_filter').css('display', 'none'),
      ajax: (dataTablesParameters: any, callback: Function) => {
        this.IsLoading = true;
        const filter =
        {
          UserId: this.authService.user["Id"]
        }
        dataTablesParameters.Extra_param = filter;
        const httpHeader = this.valdateService.GetAuthHeader();
        that.http.post<DataTablesResponse>(
          this.BASE_URL + '/opportunity/1031InquiryList/',
          dataTablesParameters, httpHeader
        ).subscribe(resp => {
          that.inquiryList = resp.data ? resp.data : [];
          if (resp) {
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
            if (resp.data.length === 0) {
              $(".dataTables_paginate.paging_full_numbers").hide();
            }
            else {
              $(".dataTables_paginate.paging_full_numbers").show();
            }
            $(".paginate_button.first,.paginate_button.last").hide();
          } else {
            callback({
              recordsTotal: 0,
              recordsFiltered: 0,
              data: []
            });
            $(".dataTables_paginate.paging_full_numbers").hide();
          }
          this.IsLoading = false;
        });
      },
      columns: [{ data: 'InquiryDate' },
      { data: 'SalePrice' },
      { data: 'ProjectedSaleDate' },
      { data: 'Status' },
      ]
    };
  }
  onSearch(text: string) {
    this.dtElement.dtInstance.then(x => x.search(text).draw());
  }
}
